import styled from 'styled-components';

import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Button as ButtonLayout, Text as TextLayout } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  &&&{
    width: 340px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ButtonCancel = styled(ButtonLayout.Inverted)`
  min-width: 110px;
`;

export const ButtonConfirm = styled(ButtonLayout)`
  min-width: 110px;
`;

export const Text = styled(TextLayout.Header)`
  text-align: center;
  margin-bottom: 45px;
`;

export const Content = styled.div`
  display: block;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
`;
